export const GET_PAYMENT_URL = 'GET_PAYMENT_URL';

export function getPaymentURL(id, payment_provider) {
  return {
    type: GET_PAYMENT_URL,
    request: {
      op: 'post',
      path: `@start-payment`,
      data: {
        pratica_id: id,
        // TODO: da rimuovere in futuro
        payment_provider: payment_provider,
      },
    },
  };
}
